import $ from 'jquery';
import dt from 'datatables.net-dt';
import 'datatables.net-responsive';
import 'datatables.net-colreorder';
// import './ColReorderWithResize';
import 'datatables.net-scroller';
import 'datatables.net-buttons-dt';
import 'datatables.net-fixedcolumns-dt';
import { isSessionStorageAvailable, escapeRegExp, removeEscapeChars } from './utilities';
import {standardAjaxPost} from "stdjs/standard-ajax";
import {displayMessages } from 'stdjs/validation';
import Translator from "./translate-service";
import _ from 'underscore';

import "stdjs/scrollResize-fudge"; // TODO - sort this out (Aaron gave up for a bit)

var datatablesStandardDom = "rt<'bottomLeft'i><'bottomRight'p><'clear'>";

var sessionStorageAvailable = isSessionStorageAvailable();

export function defineTable(tableSelector, columns, pageSize, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, storageLocation, responsive = true, colReorder = true, csvButton = false, fixedColumns = 0, scrollOnPaginate = true, scrollResize = true) {

    if (pageSize === 0) {
        return defineTableFull(tableSelector, columns, false, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, "irt<'bottomLeft'Bl><'bottomRight'p><'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    } else {
        return defineTableFull(tableSelector, columns, true, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, "irt<'bottomLeft'Bl><'bottomRight'p><'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    }
    
}

export function defineTableClear(tableSelector, columns, pageSize, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, storageLocation, responsive = true, colReorder = true, csvButton = false, fixedColumns = 0, scrollOnPaginate = true, scrollResize = true) {

    if (pageSize === 0) {
        return defineTableFull(tableSelector, columns, false, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, "rt<'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    } else {
        return defineTableFull(tableSelector, columns, true, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, "rt<'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    }
    
}

export function defineTableStatic(tableSelector, colDefs, zeroRecords, responsive = true) {

    return defineTableFull(tableSelector, [], false, 9999, false, [], [], colDefs, zeroRecords, false, [], [], [], [], "rt<'clear'>", responsive, false);
    
}

function defineTableFull(tableSelector, columns, paging, pageSize, ordering, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, dom, storageLocation, responsive = true, colReorder = true, csvButton = false, fixedColumns = 0, scrollOnPaginate = true, scrollResize = true) {
 
    $.fn.dataTable.ext.classes.sPageButton = 'btn stdButton m-2 tablePageButton';

    var scrollTableSelector = tableSelector + "_wrapper";

    console.log(dom);

    /**
     * Create the table filters before columns are hidden
     * and indexes become mismatched. This is the only time
     * we can guarantee that all the columns will be visible
     */
    /*$(tableSelector + " thead tr.search th").each(function(i, el){        
        $(el).attr("data-colIdx", i);
        $(el).attr("data-colName", columns[i].name);
        switch (columns[i].searchType) {
            case "*INPUT":
                inputFilter(tableSelector, columns, i);
                break;
            case "*CHECKBOX":
                checkboxFilter(tableSelector, columns, i);
                break;
            case "*DATE":
                dateFilter(tableSelector, columns, i);
                break;
            case "*SELECT":
                selectFilter(tableSelector, columns, i);
                break;
            
            case null:
                break;
        
            default:
                break;
        }
    });*/

    var buttonsVal = [];

    if(csvButton){
        var buttonsVal = [{
            extend: 'csv',
            text: Translator.tr("CSV Export"),
            exportOptions: {
                modifier: {
                    search: 'none'
                },
                orthogonal: "filter",
                customizeData: function(data){
                    
                    /**
                     * All this is to make sure invisible columns are put to the end of the csv
                     */
                    var visData = {
                        header: [],
                        footer: null,
                        body: []
                    };

                    var invisData = {
                        header: [],
                        footer: null,
                        body: []
                    };

                    $.each(data.header, function(index, value){
                        $.each(table.columns().header(), function(i, v){
                            if(v.innerText == value){
                                if(table.column(i).visible()){
                                    visData.header.push(data.header[index]);

                                    $.each(data.body, function(idx, val){
                                        if(typeof visData.body[idx] == "undefined"){
                                            visData.body[idx] = [];
                                        }
                                        visData.body[idx].push(val[index]);
                                    });
                                } else {
                                    invisData.header.push(data.header[index]);

                                    $.each(data.body, function(idx, val){
                                        if(typeof invisData.body[idx] == "undefined"){
                                            invisData.body[idx] = [];
                                        }
                                        invisData.body[idx].push(val[index]);
                                    });
                                }
                            }
                        });
                    });

                    var ordered = {
                        header: [],
                        footer: null,
                        body: []
                    };

                    ordered.header = ordered.header.concat(visData.header);
                    ordered.body = ordered.body.concat(visData.body);
                    ordered.header = ordered.header.concat(invisData.header);

                    $.each(invisData.body, function(i, v){
                        ordered.body[i] = ordered.body[i].concat(v);
                    });

                    data.body = ordered.body;
                    data.header = ordered.header;
                }
            }
        }];
    }

    var table = $(tableSelector).DataTable({
        autoWidth: false,
        responsive: responsive,
        columnDefs: colDefs,
        order: defaultSort,
        orderFixed: fixedSort,
        orderCellsTop: true,
        processing: false,
        paging: paging,
        ordering: ordering,
        pagingType: "full_numbers",
        lengthMenu: [10, 25, 50, 100],
        pageLength: pageSize,
        dom: dom,
        info: false, // todo remove

        data: [],
        columns: columns,
        deferRender: true,

        colReorder: false,
        scrollY: false,
        scrollX: false,
        scrollResize: false,
        scrollCollapse: true,
        buttons: buttonsVal,

        fixedColumns: responsive ? null : {leftColumns: fixedColumns},

        language: {
            lengthMenu: " " + Translator.tr("_MENU_ records per page"),
            zeroRecords: Translator.tr(zeroRecords),
            infoEmpty: Translator.tr("No records available"),
            infoFiltered: "( " + Translator.tr("_MAX_ total records") + " )",
            paginate: {
                first: Translator.tr("First"),
                last: Translator.tr("Last"),
                previous: Translator.tr("Previous"),
                next: Translator.tr("Next")
            }
        },
        stateSave: stateSave,
        stateDuration: -1,
        stateLoadCallback: function (settings, data) {
            if (sessionStorageAvailable) {
                var state = JSON.parse(sessionStorage.getItem(storageLocation));
                /**
                 * Setting up the filters earlier won't have been able to 
                 * get the previous state as the table won't have been initialised
                 * Do it here instead
                 */
                if (state){

                    /**
                     * Use this as a basic reset for when the columns in
                     * the backend change.
                     * If we have a different number of columns or
                     * we can't find a match for each column, delete the
                     * stored state.
                     */
                    var resetFilters = false;
                    if (columns.length !== state.columns.length) {
                        resetFilters = true;
                    } else {
                        resetFilters = !columns.reduce((acc, col) => {
                            return acc && state.columns.find( el => el.name === col.name) !== undefined;
                        }, true);
                    }

                    if (resetFilters) {
                        sessionStorage.removeItem(storageLocation);
                        return false;
                    }

                    $(tableSelector + " thead tr.search th").each(function (i, el) {

                        /**
                         * The column index can change if new columns are added
                         * or columns are removed etc, so we can't go by column index.
                         * Instead, match columns to state using the column name.
                         */
                        var colName = $(el).attr("data-colName");
                        var colIdx = $(el).attr("data-colIdx");
                        if (colName === undefined || colIdx === undefined) {
                            return;
                        }

                        /**
                         * To optimise, check if the indexes match so we don't have to filter through
                         * each array
                         */
                        var col;
                        var stateCol;
                        if (colIdx < columns.length && colIdx < state.columns.length && columns[colIdx].name != undefined && columns[colIdx].name === state.columns[colIdx].name) {
                            col = columns[colIdx];
                            stateCol = state.columns[colIdx];
                        } else {
                            col = columns.filter((col) => col.name != undefined && col.name === colName);
                            if (col.length === 0){
                                return;
                            }
                            col = col[0];
    
                            stateCol = state.columns.filter((col) => col.name != undefined && col.name === colName);
                            if (stateCol.length === 0){
                                return;
                            }
                            stateCol = stateCol[0];
                        }


                        var searchType;
                        var searchVal;
                        try {
                            searchType = col.searchType;
                            searchVal = stateCol.search.search;
                        } catch (e) {
                            return;
                        }
                        
                        switch (searchType) {
                            case "*INPUT":
                                var input = $("input", el);
                                input.val(searchVal);
                                break;
                            case "*CHECKBOX":
                                var input = $("input", el);
                                if (searchVal === "1") {
                                    input.prop("checked", true);
                                }
                                break;
                            case "*DATE":
                                var input = $("input", el);
                                try {
                                    input[0]._flatpickr.setDate(searchVal);
                                } catch (e) {
                                    console.error(e);
                                }
                                break;
                            case "*SELECT":
                                // This is prefilled when we update the selects anyway
                                break;
    
                            default:
                                break;
                        }
    
                    });
                }
                return state || false;
            }
        },
        stateSaveCallback: function (settings, data) {
            if (sessionStorageAvailable) {
                // Save the col name with the search data etc.
                data.columns = data.columns.map((col, colIdx) => {
                    var searchCell = $("tr.search th:eq(" + colIdx + ")", tableSelector);
                    col.name = searchCell.attr("data-colName");
                    return col;
                });
                sessionStorage.setItem(storageLocation, JSON.stringify(data));
            }
        },
        initComplete: function(settings, json) {
            $(scrollTableSelector).append(`
                <div class="dataLoadingCover tableDataLoadingCover" style="display: none;">
                    <img src="/images/ajax-loader.gif" alt="">
                </div>
            `);
            $(tableSelector).show();
        },
        drawCallback: function(settings) {

            $.each($(".dataTables_scrollBody thead tr:not(.search) th.sizeToContent", scrollTableSelector), function(i, v){
                $(v).css("width", "1%");
            });

            var widths = [];

            $.each($(".dataTables_scrollBody thead tr:not(.search) th", scrollTableSelector), function(i, v){
                widths[i] = $(v).css("width");
                //widths[i] = $(v).outerWidth();
            });

            $.each($(".dataTables_scrollHead thead tr:not(.search) th", scrollTableSelector), function(i, v){
                $(v).width(widths[i]);
                //$(v).outerWidth(widths[i]);
            });
        }
    });
    //new $.fn.dataTable.ColReorder(table);
    // createSearchRow(table); not needed now thead in html again

    if (responsive){


        responsiveResize(table, scrollTableSelector, columns);
        table.on("responsive-resize", function(){
            responsiveResize(table, scrollTableSelector, columns);
        });
    }

    if (scrollOnPaginate){
        table.on('page.dt', function() {
            $('html, body').animate({
              scrollTop: $(tableSelector + "_wrapper").offset().top
            });
        });
    }

    // TODO if you edit the name of one of the fixed columns it plays havoc with the table resizing.
    if(fixedColumns > 0){

        $("table.DTFC_Cloned tr.search th input", scrollTableSelector).each(function(i, v){
            var colIdx = $(v).closest("th").data("colidx");
            var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
            if (isDataTable){
                var state = $(tableSelector).DataTable().state();
                if (state !== null) {
                    $(v).val(state.columns[colIdx].search.search);
                }
            }
        });

        $(scrollTableSelector).on("keyup", "table.DTFC_Cloned tr.search th input", function(e){

            var colIdx = $(this).closest("th").data("colidx");
            var cursorStart = $(this)[0].selectionStart;
            // var cursorEnd = $(this)[0].selectionEnd;

            $(".dataTables_scrollHead tr.search th[data-colidx='" + colIdx + "'] input", scrollTableSelector).val($(this).val());
            $(".dataTables_scrollHead tr.search th[data-colidx='" + colIdx + "'] input", scrollTableSelector).trigger("keyup");
            $("table.DTFC_Cloned tr.search th[data-colidx='" + colIdx + "'] input").focus();
            $("table.DTFC_Cloned tr.search th[data-colidx='" + colIdx + "'] input")[0].selectionStart = cursorStart;
            $("table.DTFC_Cloned tr.search th[data-colidx='" + colIdx + "'] input")[0].selectionEnd = cursorStart;
        });

    }

    /*$(window).resize(function(){
        table.columns.adjust().draw();
    });

    if(colReorder){
        table.colReorder.disable();
    }

    var state = $(tableSelector).DataTable().state();
    if (state !== null) {
        if(colReorder){
            table.colReorder.reset();
        }
    }*/

    return table;
}

export function getTableWrapper( tableId ){
    return $( "#" + tableId + "_wrapper" );
}

export function showSearchRow( tableId ){
    var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
    searchRow.show();
}

export function hideSearchRow( tableId ){
    var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
    searchRow.hide();
}

function createSearchRow(table){
    var header = $(table.table().header());
    var searchRow = $("<tr class='search' />").appendTo(header);
    $.each(header.get(0).rows[0].cells, function(index, value){
        $("<th />").appendTo(searchRow);
    });
}

function selectFilter(tableSelector, columns, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === ""){
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
        var select = $('<select />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("change", function () {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable){
                    var value = $(this).val();
                    if (value.length > 0) {
                        value = "^" + escapeRegExp(value) + "$";
                    }
                    $(tableSelector).DataTable()
                        .column(columns[colIdx].name + ":name")
                        .search(value, true, false, false)
                        .draw();
                }
            });

            select.append($("<option value=\"\">&nbsp;</option>"));

            var filterValues = [""];
            
            if (isDataTable){
                var apiObject = $(tableSelector).DataTable();

                apiObject
                    .column(colIdx)
                    .cache("search")
                    .sort()
                    .unique()
                    .each( function (d) {
                        filterValues.push(d);
                        if (d !== "") {
                            select.append($("<option value=\"" + d + "\">" + d + "</option>"));
                        }
                    });
    
                var state = apiObject.state();
                if(state !== null){
                    var stateValue = state.columns[colIdx].search.search;
                    if ($.inArray(stateValue, filterValues) === -1){
                        select.append($("<option value=\"" + stateValue + "\">" + stateValue + "</option>"));
                    }
                    select.val(stateValue);
                }
            }
    }
}

function inputFilter(tableSelector, columns, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === ""){
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
        var input = $('<input type="text" />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("keyup", function () {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable){
                    $(tableSelector).DataTable()
                        .column(columns[colIdx].name + ":name")
                        .search($(this).val(), false, false, true)
                        .draw();
                }
            });
    
        if (isDataTable){
            var state = $(tableSelector).DataTable().state();
            if (state !== null) {
                input.val(state.columns[colIdx].search.search);
            }
        }
    }
}

function checkboxFilter(tableSelector, columns, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === "") {
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
        var input = $('<input type="checkbox" />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("click", function () {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable) {
                    if ($(this).is(":checked")) {
                        $(tableSelector).DataTable()
                            .column(columns[colIdx].name + ":name")
                            .search("1", false, false, true)
                            .draw();
                    } else {
                        $(tableSelector).DataTable()
                            .column(columns[colIdx].name + ":name")
                            .search("", false, false, true)
                            .draw();
                    }
                }
            });

        if (isDataTable) {
            var state = $(tableSelector).DataTable().state();
            if (state !== null) {
                if ($(tableSelector).DataTable().state().columns[colIdx].search.search === "1") {
                    input.prop("checked", true);
                }
            }
        }
    }
}

function dateFilter(tableSelector, columns, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === "") {
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
        var input = $('<input data-text="test" type="text" />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("keyup", function (e) {
                if (e.keyCode === 8 || e.keyCode === 46) {
                    datepicker.clear();
                    datepicker.close();
                }
            });

        var datepicker = $(input).flatpickr({
            enableTime: false,
            dateFormat: "d/m/Y",
            altInput: true,
            altFormat: userDateFormat,
            disableMobile: true,
            allowInput: true,
            onChange: function (selectedDates, dateText, inst) {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable){
                    $(tableSelector).DataTable()
                        .column(columns[colIdx].name + ":name")
                        .search(dateText, false, false, true)
                        .draw();
                }
            }
        });

        if (isDataTable){
            var state = $(tableSelector).DataTable().state();
            if (state !== null && state.columns[colIdx].visible) {
                datepicker.setDate(state.columns[colIdx].search.search);
            }
        }
    }
}

function removeFilters(apiObject, domObject) {

    apiObject.columns().flatten().each(function(colIdx) {

        if ($("tr.search th:eq(" + colIdx + ") input, tr.search th:eq(" + colIdx + ") select", domObject).length){
            $("tr.search th:eq(" + colIdx + ")", domObject).html("");
        }
        
    });
    
}

export function checkClickedRow(jTarget, clickedRow) {
    return !clickedRow.hasClass("child") 
            && !jTarget.hasClass("dataTables_empty") 
            && (jTarget.hasClass("controlColumnContent") 
                    || jTarget.is("img.profile-circle") 
                    || (jTarget.is("td") && !jTarget.hasClass("controlColumn"))
                );
}

function responsiveResize(table, scrollTableSelector, columns){
    table.columns().flatten().each(function(colIdx){
        if(table.columns().responsiveHidden()[colIdx]){
            $(".dataTables_scrollHead table thead tr.search th:eq(" + colIdx + ")", scrollTableSelector).show();
        } else {
            $(".dataTables_scrollHead table thead tr.search th:eq(" + colIdx + ")", scrollTableSelector).hide();
        }
    });

    // removeFilters(table, tableSelector);
    // selectFilters(table, tableSelector, columns);
    // inputFilters(table, tableSelector, columns);
    // checkboxFilters(table, tableSelector, columns);
    // datepickerFilters(table, tableSelector, columns);            

}

function getResponsiveVisibleCols(table){
    var count = 0;
    table.columns().responsiveHidden().flatten().each(function(colIdx){
        if (colIdx) {
            count++;
        }
    });
    return count;
}

export function updateSelectFilters(apiObject, domObject) {
    apiObject.columns().flatten().each(function (colIdx) {

        if ($(`tr.search th[data-colIdx=\"${colIdx}\"] select`, domObject).length > 0) {

            var select = $(`tr.search th[data-colIdx=\"${colIdx}\"] select`, domObject);
            select.empty();

            select.append($("<option value=\"\">&nbsp;</option>"));

            var filterValues = [""];

            apiObject
                .column(colIdx)
                .cache("search")
                .sort()
                .unique()
                .each(function (d) {
                    filterValues.push(d);
                    if (d !== "") {
                        select.append($("<option value=\"" + _.escape(d) + "\">" + _.escape(d) + "</option>"));
                    }
                });

            var state = apiObject.state();
            if (state !== null) {
                var stateValue = state.columns[colIdx].search.search;
                if (stateValue.length > 0) {
                    if (stateValue[0] === "^") {
                        stateValue = stateValue.slice(1);
                    }
                }
                if (stateValue.length > 0) {
                    if (stateValue[stateValue.length - 1] === "$") {
                        stateValue = stateValue.slice(0, -1);
                    }
                }
                stateValue = removeEscapeChars(stateValue);
                if ($.inArray(stateValue, filterValues) === -1) {
                    select.append($("<option value=\"" + stateValue + "\">" + stateValue + "</option>"));
                }
                select.val(stateValue);
            }

        }

    });
}

export function updateColumnConfigs(table, tableReference, successCallback){
    if (typeof successCallback === "undefined" || typeof successCallback !== "function"){
        successCallback = null;
    }
    
    var colInfo = getColumnInfo(table);
    var data = {
        table: tableReference,
        columnInfo: colInfo
    };

    standardAjaxPost(updateUserColumnConfigUrl, data, successCallback, null, false);
}

export function getColumnInfo(table){

    var columns = table.settings().init().columns;

    var colInfo = {};

    for(var i=0; i<columns.length; i++){
        var colName = columns[i].name;
        var order = table.column(colName + ":name").flatten()[0];
        var visible = table.column(colName + ":name").visible();
        var name = $(table.column(colName + ":name").header()).text();

        var data = {
            name: name,
            order: order,
            visible: visible ? 1 : 0
        };

        colInfo[colName] = data;
    }

    return colInfo;

}

export function updateTableData(table, data){
    insertTableDataCore( table, data, "*CREATE" );
}

export function appendTableData( table, data ){
    insertTableDataCore( table, data, "*UPDATE" );
}

export function replaceTableData( table, data ){
    insertTableDataCore( table, data, "*REPLACE" );
}

export function removeTableRow( table, rowId ){
    var tableWrapperId = "#" + $(table.table().container()).attr("id");
    table.row( "#" + rowId ).remove().draw();
    updateSelectFilters(table, tableWrapperId);
    table.columns.adjust().draw();
}

function insertTableDataCore(table, data, mode ){
    /**
     * To reduce the size of the response
     * default the sort/filter value to the
     * display value if sort/filter are null
     */
    data.map(function(row){
        Object.keys(row).forEach(function(colName){
            if (colName !== "DT_RowId"){
                if (!row[colName].hasOwnProperty('sort') || row[colName].sort === null){
                    row[colName].sort = row[colName].display;
                }
                if (!row[colName].hasOwnProperty('filter') || row[colName].filter === null){
                    row[colName].filter = row[colName].display;
                }
            }
        });
        return row;
    });
    
    var tableWrapperId = "#" + $(table.table().container()).attr("id");
    
    if ( mode === "*CREATE" ){
        table.clear();
    }    
    
    if ( mode === "*REPLACE" ){
        $.each( data, function( index, row){
            table.row( "#" + row.DT_RowId ).remove();
        });        
    }
    
    table.rows.add(data).draw();
    updateSelectFilters(table, tableWrapperId);
    table.columns.adjust().draw();
    
    if ( mode === "*CREATE" ){
        // TODO scope this by table
        $(".tableDataLoadingCover").fadeOut();
    }
    
}

export function updateTableDataFromUrl(table, url, data = {}, dataKey = "result", successCallback = function(data){}, errorCallback = function(data){}){
    var modifiedSuccessCallback = function(data){
        if(data.success){
            var responseData = data[dataKey];
            if (responseData == null){
                $(".tableDataLoadingCover").fadeOut();
                errorCallback(data);
                return;
            }
            
            if (typeof data[dataKey] === "string"){
                try {
                    responseData = JSON.parse(responseData);
                } catch (error) {
                    console.error(error);
                    $(".tableDataLoadingCover").fadeOut();
                    errorCallback(data);
                    return;
                }
            }

            updateTableData(table, responseData);
            successCallback(data);
        } else {
            $(".tableDataLoadingCover").fadeOut();
        }
    }

    var modifiedErrorCallback = function(data) {
        $(".tableDataLoadingCover").fadeOut();
        displayMessages(data.errorMessages, data.warningMessages, data.infoMessages, data.successMessages, data.infoMessages);
        errorCallback(data);
    }

    $(".tableDataLoadingCover").fadeIn();
    standardAjaxPost(url, data, modifiedSuccessCallback, modifiedErrorCallback, false);
}

export function setColumnVisibility(table, tableReference, colName, visible){
    var tableWrapperId = "#" + $(table.table().container()).attr("id");
    var column = table.column(colName + ":name");
    
    /**
     * If we're hiding a column, remove any filters
     * and empty the input
     */
    if (!visible){
        var inputs = $(`thead tr.search th[data-colIdx=\"${column.index()}\"] input, thead tr.search th[data-colIdx=\"${column.index()}\"] select`, tableWrapperId);
        inputs.each(function(i, el){
            $(el).val("");
        });
    
        column.search("", false, false, true);
    }
    
    column.visible(visible);
    table.draw();
    updateColumnConfigs(table, tableReference);
}

/**
 * EDIT COLUMNS
 */
export function setupEditColumnsEvents(table, id, currentTableReference = null, fixedColumnSuccessCallback = null){
    var selectColumnsDropdownId = (id == null) ? "#selectColumnsDropdown" : id;

    if(currentTableReference === null) {
        currentTableReference = tableReference;
    }

    $.each($(selectColumnsDropdownId + " .switchContainer input"), function(index, value){
        var colName = $(value).data("col-name");
        if($(value).prop("checked") != table.column(colName + ":name").visible()){
            toggleCheckbox($(value).closest(".switchContainer"));
        }
    });

    $(selectColumnsDropdownId + " .columnSelectLine .switchContainer").click(function(e){
        e.stopPropagation();
        var colVis = toggleCheckbox($(this));
        setColumnVisibility(table, currentTableReference, $(this).find("input").data("col-name"), colVis);
    });

    $(selectColumnsDropdownId + " .columnSelectLine").click(function(e){
        e.stopPropagation();
        $(".switchContainer", $(this)).trigger("click");
    });

    $("input, .dragIcon", selectColumnsDropdownId + " .columnSelectLine").click(function(e){
        e.stopPropagation();
    })

    $(selectColumnsDropdownId).on("hide.bs.dropdown", function(e){
        $.each($(".columnName", $(this)), function(index, value){
            if($(value).hasClass("edit")){
                var input = $(value).find("input");
                $(value).hide();
                input.val(input.attr("data-prev-value"));
            } else {
                $(value).show();
            }
        });
        $(".fixedColumns").show();
        $(".fixedColumns.edit").hide();
    });


    $(".columnName .editName").click(function(e){
        e.stopPropagation();
        var line = $(this).closest(".columnSelectLine");
        
        if($(this).hasClass("save")){
            saveColumnName(line, $(this).closest(".columnName").find("input"));
        }
        line.find(".columnName").toggle();
        line.find(".columnName input").focus();
        line.find(".columnName input").select();
    });

    $(".columnSelectLine .columnName input").keyup(function(e) {
        if (e.keyCode !== 13){
            return;
        }

        var line = $(this).closest(".columnSelectLine");
        saveColumnName(line, $(this));
        line.find(".columnName").toggle();
    });

    
    function saveColumnName(line, input) {
        var text = input.val();
        if (text === ""){
            text = input.attr("data-default-to");
        }
        var colName = $(line).data("col-name");
        $(table.column(colName + ":name").header()).html("<div>" + text + "</div>");
        $(".columnName .text", line).text(text);
        updateColumnConfigs(table, currentTableReference);
        input.attr("data-prev-value", text);
    }

    function toggleCheckbox(switchContainer){
        var checkbox = switchContainer.find("input");
        
        if(checkbox.prop("checked")){
            checkbox.prop("checked", false);
            switchContainer.find(".checkmark").css("display", "none");
        } else {
            checkbox.prop("checked", true);
            switchContainer.find(".checkmark").css("display", "block");
        }
        return checkbox.prop("checked");
    }

    $(".fixedColumnsLine .editFixed").click(function(e){
        e.stopPropagation();
        var line = $(this).closest(".fixedColumnsLine");
        
        if($(this).hasClass("save")){
            saveFixedColumns(line.find("input"), currentTableReference, fixedColumnSuccessCallback);
        } else {
            var input = line.next(".fixedColumnsLine").find("input");
            manageEditColumnTranslation(input);
            input.focus();
            input.select();
        }
        $(".fixedColumnsLine").toggle();
    });

    $(".fixedColumnsLine input").keyup(function(e) {
        if (e.keyCode !== 13){
            return;
        }

        saveFixedColumns($(this), currentTableReference, fixedColumnSuccessCallback);
        $(".fixedColumnsLine").toggle();
    });

    $(document).on("change", ".fixedColumnsLine input", function(e) {
        manageEditColumnTranslation(this);
    });

    /**
     * This is used to translate "Fix first n columns" where the value of n
     * is the value of a html input.
     */
    function manageEditColumnTranslation(input) {
        var parent = $(input).parent();
        var value = $(input).val();
        var newInput = $(input).clone();
        newInput.attr("value", value);
        var translation = Translator.tr("Fix first {{NUM}} column.", value, { NUM: newInput[0].outerHTML });
        parent.html(translation);
    }

    function saveFixedColumns(input, currentTableReference, successCallback = null){

        var value = input.val();

        if(input.attr("min") > input.val()){
            value = 0;
        }
        if(input.attr("max") < input.val()){
            value = 5;
        }

        var data = {
            TABL10_REFE: currentTableReference,
            TABL11_FIXD: value
        };

        var callback = function(data){
            location.reload();
        }

        if (successCallback !== null) {
            callback = successCallback;
        }
        standardAjaxPost(updateFixedColumnsUrl, data, callback);
    }
    
}

/**
 * SORTABLE COLUMNS DD
 */
export function setupSortableColumnsDropdown(table, ddSelector){

    var colOrder = [];

    $(ddSelector).sortable({
        axis: "y",
        handle: ".dragIcon",
        update: function(event, ui){
            var newOrder = $(this).sortable('toArray');
            var start = -1;
            var end = -1;
            $.each(colOrder, function(i ,v){
                if(v != newOrder[i] && start == -1){
                    start = i;
                }
                if(v == newOrder[i] && start != -1 && end == -1){
                    end = i - 1;
                }
            });

            if(end == -1){
                end = colOrder.length - 1;
            }

            if(ui.position.top < ui.originalPosition.top){
                var temp = start;
                start = end;
                end = temp;
            }

            colOrder = newOrder;

            table.colReorder.move(start, end, true, true);
            table.draw();
        }
    });

    colOrder = $(ddSelector).sortable('toArray');

}


export function setupFixedColumnsEvents(table){

    var $table = $(table.table().node());
    var $tableSection = $table.closest( "#tableSection" );
                
    $tableSection.on({
        mouseenter: function(e){
            var rowId = table.row($(this)).flatten()[0];
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr[data-dt-row='" + rowId + "']", $tableSection).addClass("isHover");
        },
        mouseleave: function(e){
            var rowId = table.row($(this)).flatten()[0];
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr[data-dt-row='" + rowId + "']", $tableSection).removeClass("isHover");
            $(this).removeClass("isHover");
        },
        click: function(e){
            $(".dataTables_wrapper .dataTables_scrollBody table tbody tr", $tableSection).removeClass("isHover");
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr", $tableSection).removeClass("isHover");
            $(this).addClass("isHover");
        }
    }, ".dataTables_wrapper .dataTables_scrollBody table tbody tr");

    $tableSection.on({
        mouseenter: function(e){
            var row = table.row($(this).data("dt-row")).node();
            $(row).addClass("isHover");
        },
        mouseleave: function(e){
            var row = table.row($(this).data("dt-row")).node();
            $(".dataTables_wrapper .dataTables_scrollBody table tbody tr", $tableSection).removeClass("isHover");
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr", $tableSection).removeClass("isHover");
        },
        click: function(e){
            var row = table.row($(this).data("dt-row")).node();
            $(row).trigger("click");
        }
    }, ".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr");

}

/**
 * SHOW FILTERS CONTROLS
 */
export function initShowFilters(tableId, btn, tableReference, defValue = "0", callback = function(shown){}, overrideSession = false){
    
    btn = $(btn);
    var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
    var sessionStorageKey =`${tableReference}_TABLE_FILTER_STATUS_${storageId}`;
    var showText = Translator.tr("Show Filters");
    var hideText = Translator.tr("Hide Filters");

    var storedValue = defValue;
    if (!overrideSession && isSessionStorageAvailable) {
        storedValue = sessionStorage.getItem(sessionStorageKey);
        if (storedValue === null) {
            storedValue = defValue;
        }
    } else {
    }

    if (storedValue == "1") {
        btn.text(hideText);
        btn.attr("data-active", "1");
        searchRow.show();
        if (isSessionStorageAvailable) {
            sessionStorage.setItem(sessionStorageKey, "1");
        }
    } else {
        btn.text(showText);
        btn.attr("data-active", "0");
        searchRow.hide();
        if (isSessionStorageAvailable) {
            sessionStorage.setItem(sessionStorageKey, "0");
        }
    }

    btn.on("click", function(){
        var shown;
        var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
        if ($(this).attr("data-active") === "1"){
            $(this).text(showText);
            $(this).attr("data-active", "0");
            shown = false;
            searchRow.hide();
            if (isSessionStorageAvailable){
                sessionStorage.setItem(sessionStorageKey, "0");
            }
        } else {
            $(this).text(hideText);
            $(this).attr("data-active", "1");
            shown = true;
            searchRow.show();
            if (isSessionStorageAvailable){
                sessionStorage.setItem(sessionStorageKey, "1");
            }
        }
        
        callback(shown);
    });
}


export function tableButtonHasClass( $button, className ){
    
    if ( $button.hasClass( className ) ){
        return true;
    }
    
    var $parentButton = $button.closest( "button" );
    
    return $parentButton.hasClass( className );
        
}

export function getTableButtonData( $button, dataName ){
    var data = $button.data( dataName );
    
    if ( typeof data !== "undefined" ){
        return data;
    }
    
    var $parentButton = $button.closest( "button" );
    
    return $parentButton.data( dataName );

}

export function initSelectAllRows( table, $selectAllRowsButton, $bulkActionDropdownButton ){
    $selectAllRowsButton.click(function(e){

        var $button = $(this);

        var pageNumber = table.page.info().page;
        var allSelectedPages = JSON.parse( $selectAllRowsButton.attr("data-selected") );

        var isSelected = allSelectedPages.includes( pageNumber );
        
        table.rows({order: "current", page: "current", search: "applied"}).nodes().each(function(row, idx){
            if (isSelected){
                $(row).removeClass("rowSelected");
            } else {
                $(row).addClass("rowSelected");
            }
        });

        if (isSelected){

            /**
             * Re-form the selected pages array
             */
            var newAllSelectedPages = [];
            $.each( allSelectedPages, function( i, v ){
                if( v != pageNumber ){
                    newAllSelectedPages.push( v );
                }
            });

            $button.attr("data-selected", JSON.stringify( newAllSelectedPages ));
            $button.text($button.attr("data-select-text"));
        } else {
            allSelectedPages.push( pageNumber );
            $button.attr("data-selected", JSON.stringify( allSelectedPages ));
            $button.text($button.attr("data-unselect-text"));
        }

        updateTableGroupActions(table, $bulkActionDropdownButton, $selectAllRowsButton);
    });

    table.on('page.dt', function() {

        var pageNumber = table.page.info().page;
        
        var allSelectedPages = JSON.parse( $selectAllRowsButton.attr("data-selected") );

        // If the user has clicked "Select All Rows" on this page then update the button to indicate this
        if( allSelectedPages.includes( pageNumber ) ){
            $selectAllRowsButton.text($selectAllRowsButton.attr("data-unselect-text"));
        } else {
            $selectAllRowsButton.text($selectAllRowsButton.attr("data-select-text"));
        }

        updateTableGroupActions(table, $bulkActionDropdownButton, $selectAllRowsButton);
    });

    table.on('length.dt', function() {
        $selectAllRowsButton.text($selectAllRowsButton.attr("data-select-text"));
        $selectAllRowsButton.attr("data-selected", "[]");
        updateTableGroupActions(table, $bulkActionDropdownButton, $selectAllRowsButton);
    });
}


export function updateTableGroupActions(table, $bulkActionDropdownButton, $selectAllRowsButton ){

    var rows = table.rows().nodes();
    var rowCount = rows.length;

    var selectedCount = 0;
    rows.each(function(row, idx){
        if ($(row).hasClass("rowSelected")){
            selectedCount++;
        }
    });

    if (selectedCount > 0){
        $bulkActionDropdownButton.attr("data-toggle", "dropdown");
        $bulkActionDropdownButton.removeClass("disabled");
        // if (rowCount == selectedCount){
        //     $selectAllRowsButton.attr("data-selected", true);
        //     $selectAllRowsButton.text($selectAllRowsButton.attr("data-unselect-text"));
        // } else {
        //     $selectAllRowsButton.attr("data-selected", false);
        //     $selectAllRowsButton.text($selectAllRowsButton.attr("data-select-text"));
        // }
    } else {
        if($bulkActionDropdownButton.parent().find(".dropdown-menu").hasClass("show")){
            $bulkActionDropdownButton.dropdown("toggle");
        }
        $bulkActionDropdownButton.removeAttr("data-toggle", "dropdown");
        $bulkActionDropdownButton.addClass("disabled");
    }
}

export function toggleTableRowSelect( table, $row, $bulkActionDropdownButton, $selectAllRowsButton ){
    if ($($row).hasClass("rowSelected")){
        $($row).removeClass("rowSelected");
    } else {
        $($row).addClass("rowSelected");
    }
    updateTableGroupActions(table, $bulkActionDropdownButton, $selectAllRowsButton );
}

export function processGroupActionEvents( dataTable, $parentContainer, groupOptionCallBack ){
    $parentContainer.on( "click", ".group-option", function( e ){
        e.stopImmediatePropagation();
        e.stopPropagation();
                    
        var $clickedGroupOption = $(e.target);            
        if ( !$clickedGroupOption.is( ".group-option" ) ){
            $clickedGroupOption = $clickedGroupOption.closest( ".group-option" );
        }
        
        if($parentContainer.parent().find(".dropdown-menu").hasClass("show")){
            $parentContainer.find(".stdTableBulkActionDropdown").dropdown("toggle");
        }
        
        // TODO make dropdown disappear.
        var $selectedRows = dataTable.rows( ".rowSelected", {order: "current", page: "all", search: "none"} ).nodes();
        
        if ( !$selectedRows.length ){
            return false;
        } 
        
        
        groupOptionCallBack( $clickedGroupOption, $selectedRows );
        
        
        
    } );
}

export function filterTableColumns(table, tableSelector, filters = {}){

    $.each(filters, function(i, v){
        table.column(i + ":name").search(v);

        var searchCol = $('.dataTables_scrollHead tr.search th[data-colname="' + i + '"]', tableSelector + "_wrapper");
        if(searchCol.length){
            
            var input = $(searchCol).find("input");
            if(input.length){
                $(input).val(v);
            }
        }
    });
}